export const getRobotVolume = async (
  robotIp: string | undefined
): Promise<number> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/audio/volume`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot Volume returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const setRobotVolume = async (
  robotIp: string | undefined,
  newVolume: number
): Promise<boolean> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/audio/volume`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ new_volume: newVolume }),
  });

  if (!response.ok) {
    throw new Error(
      `Setting Robot Volume returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const changeRobotVolume = async (
  robotIp: string | undefined,
  volumeChange: number
): Promise<boolean> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/audio/volume`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ volume_change: volumeChange }),
  });

  if (!response.ok) {
    throw new Error(
      `Changing Robot Volume returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};
